module.exports = __webpack_public_path__ + "static/media/Dori.9b5c8d26.png";